import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Sidebar from './Sidebar'
import Navbar from './Navbar'

export class Layout extends Component {
  static propTypes = {
    isSidebar: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.node,
    backTo: PropTypes.string,
    navItems: PropTypes.array,
    isFullNavbar: PropTypes.bool,
  }

  state = {
    isSidebarActive: false,
  }

  toggleSidebarActive = () => {
    this.state.isSidebarActive
      ? document.body.classList.remove('sidebar-open')
      : document.body.classList.add('sidebar-open')
    this.setState(state => ({ isSidebarActive: !state.isSidebarActive }))
  }

  render() {
    const { isSidebarActive } = this.state
    const { isSidebar, title, children, backTo, navItems, isFullNavbar } = this.props

    return (
      <>
        <Navbar
          backTo={backTo}
          isFullNavbar={isFullNavbar}
          isSidebar={isSidebar}
          title={title}
          toggleSidebarActive={this.toggleSidebarActive}
        />
        {isSidebar && (
          <Sidebar
            isFullNavbar={isFullNavbar}
            isOpen={isSidebarActive}
            navItems={navItems}
            title={'Canopy'}
            toggleSidebarActive={this.toggleSidebarActive}
          />
        )}
        <main className={cn('layout', { '-full-navbar': isFullNavbar })}>{children}</main>
      </>
    )
  }
}

export default Layout
